// src/components/AyseLadyLogo.js
import React from 'react';
import { BookOpen } from 'lucide-react';

const AyseLadyLogo = () => (
  <div className="flex items-center justify-center mb-6">
    <div className="bg-gradient-to-r from-pink-500 to-purple-600 rounded-full p-3 mr-3 shadow-lg">
      <BookOpen className="w-8 h-8 text-white" />
    </div>
    <div>
      <h1 className="text-3xl font-bold bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent">
        AyseLady
      </h1>
      <p className="text-sm text-gray-600 -mt-1">İngilizce Öğrenme Oyunu</p>
    </div>
  </div>
);

export default AyseLadyLogo;